<template>
  <div class="main-nav">
    <a :href="PORTAL_LINK | langParam" target="_blank" class="tiger-logo">
      <img src="~assets/logo.png" />
    </a>
    <nav>
      <ul class="main-links">
        <li
          v-for="(menu, index) in menuList"
          :key="index"
          v-track.click="menu.track"
          @click="closeSideTrade"
        >
          <router-link :to="menu.to">
            <icon :name="menu.icon" />
            <span> {{ $t(menu.name) }} </span>
          </router-link>
        </li>
      </ul>

      <ul class="sibling-links">
        <li>
          <a
            v-track:navigation_settings.click
            href
            @click.prevent.stop="openSettingsPanel"
          >
            <icon name="gear" />
          </a>
        </li>
        <li>
          <a
            v-track:navigation_overview.click
            href
            @click.prevent.stop="showAccountDialog"
          >
            <icon name="people" />
          </a>
        </li>
        <li>
          <a
            v-track:navigation_messages.click
            href
            @click.prevent.stop="showMessageBox"
          >
            <icon name="message" />
            <span v-if="hasUnreadMsg" class="info-dot" />
          </a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import Icon from 'com/Icon'
import { mapGetters } from 'vuex'
import { PORTAL_LINK } from 'const/link'
import * as types from 'store/mutation-types'

export default {
  name: 'MainNav',
  components: { Icon },
  data() {
    return {
      PORTAL_LINK
    }
  },
  computed: {
    ...mapGetters(['hasUnreadMsg']),
    user() {
      return this.$store.state.account.info || {}
    },
    menuList() {
      return [
        {
          to: '/quote',
          icon: 'chart-column',
          name: 'menu.quote',
          track: 'navigation_stocks'
        },
        {
          to: '/quotation',
          icon: 'quotation',
          name: 'menu.quotation',
          track: 'navigation_markets'
        },
        {
          to: '/news',
          icon: 'news',
          name: 'menu.news',
          track: 'navigation_news'
        },
        {
          to: '/discovery',
          icon: 'arrow-increase',
          name: 'menu.discover',
          track: 'navigation_discover'
        },
        {
          to: '/asset',
          icon: 'wallet',
          name: 'menu.account',
          track: 'navigation_accounts'
        }
      ].filter(Boolean)
    }
  },
  methods: {
    openSettingsPanel() {
      this.$store.dispatch('updateSettings', { visible: true })
    },
    showAccountDialog() {
      this.$store.commit(types.UPDATE_ACCOUNT_VISIBLE, true)
    },
    showMessageBox() {
      this.$store.commit(types.UPDATE_MSG_VISIBLE, true)
    },
    closeSideTrade() {
      this.$store.dispatch('setOrderDetail', null)
      this.$store.dispatch('closeSideStockView')
    }
  }
}
</script>

<style lang="less" scoped>
@import '~uikit';
.main-nav {
  width: 60px;
  height: 100%;
  display: flex;
  flex-flow: column;
  overflow: hidden;
  background-color: var(--bg-block);

  .tiger-logo {
    width: 60px;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--logo-bg);
    img {
      width: 30px;
      background: #ffe100;
      border-radius: 50%;
    }
  }

  nav {
    display: flex;
    flex: 1;
    flex-flow: column;
    justify-content: space-between;
    padding-bottom: 39px;
    overflow-y: auto;
  }

  li {
    position: relative;
    margin: 0;
    padding: 0;
    width: 100%;
    height: 60px;
    text-align: center;
    svg {
      width: 20px;
      height: 20px;
    }
  }
  li a {
    width: 100%;
    height: 60px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    line-height: inherit;
    color: #838d9e;
  }
  .main-links li a.router-link-active {
    color: var(--menu-color);
    background-color: var(--menu-bg);
  }
  li i {
    display: block;
    margin-bottom: 2px;
    font-size: 20px;
  }
  li span {
    font-size: 12px;
    line-height: 20px;
  }
  .info-dot {
    position: absolute;
    width: 6px;
    height: 6px;
    border-radius: 3px;
    background-color: @red;
    top: 20px;
    right: 17px;
  }
}
.user-logout {
  display: none;
}
</style>
